import Vue from 'vue';
import { Plugin } from 'vue2-storage';

Vue.use(Plugin, {
  prefix: 'painstory_',
  driver: 'local',
  ttl: 0,
});
